import type { ReactNode } from 'react';
import { Children } from 'react';

import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './GridItem.module.scss';

const cls = cssModules(STYLES);

type Props = {
  children: ReactNode;
  imageNumber: number;
};

const GridItem = ({ children, imageNumber }: Props) => (
  <div className={cls('GridItem', `GridItem__${imageNumber}`)}>
    {Children.map(children, (child) => (
      <div className={cls('GridItem--item', `GridItem__${imageNumber}--item`)}>
        {child}
      </div>
    ))}
  </div>
);

export default GridItem;
